import React from "react";
import { Modal } from "react-bootstrap";
import SmallLoader from "../smallLoader";

const CommonModal = ({
    show,
    onHide,
    size = "md",
    title,
    children,
    className = "",
    centered = true,
    backdrop = true,
    keyboard = true,
    loader,
    showFooter = false,
    showCancelButton = true,
    cancelText = "Cancel",
    confirmText = "Confirm",
    onCancel,
    onConfirm,
    confirmDisabled = false,
    footerClassName = "",
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size={size}
            centered={centered}
            backdrop={backdrop}
            keyboard={keyboard}
            className={className}
        >
            <Modal.Header className="mb-4 modal-header">
                <Modal.Title>
                    <p>{title}</p>
                </Modal.Title>

                <div className="close-button-modal approval-modal-wrap">
                    <button
                        type="button"
                        onClick={onHide}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </div>
            </Modal.Header>

            <Modal.Body>
                {children}

                {showFooter && (
                    <div
                        className={`modal-footer-actions check-approve-modal ${footerClassName}`}
                    >
                        {showCancelButton && (
                            <button
                                type="button"
                                className="back-btn"
                                onClick={onCancel || onHide}
                            >
                                {cancelText}
                            </button>
                        )}

                        <button
                            type="submit"
                            className="submit-btns"
                            onClick={onConfirm}
                            disabled={confirmDisabled}
                        >
                            {loader ?
                            <SmallLoader />
                            :
                            <>{confirmText}</>
                            }
                        </button>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default CommonModal;